import React, { useEffect, useRef } from 'react'
import dateFormat from "dateformat";
import { createChart } from "lightweight-charts";

const MobileNewCoinCandle = ({ data }) => {

    const { newSeries, liveData, currentTimeFrame, PeriodChangeFun, setChartReady } = data;


    const chartContainerRef = useRef();
    var chart = useRef(null);



    const chartOptions = {
        layout: {
            textColor: "white",
            background: { type: "solid", color: "rgb(11, 6, 25)" },
        },
        grid: {
            vertLines: {
                color: "transparent",
            },
            horzLines: {
                color: "transparent",
            },
        },
        localization: {
            priceFormatter: (price) => Number(price).toFixed(2),
        },
        width: chartContainerRef.current && chartContainerRef.current.offsetWidth,
        height: window.innerWidth / 1.5,
    };

    useEffect(() => {
        chart.current = createChart(chartContainerRef.current, chartOptions);
        newSeries.current = chart.current.addCandlestickSeries({
            upColor: "#26a69a",
            downColor: "#ef5350",
            borderVisible: false,
            wickUpColor: "#26a69a",
            wickDownColor: "#ef5350",
        });

        // chart.current.timeScale().fitContent();
        chart.current.timeScale().scrollToPosition(5);

        chart.current.timeScale().applyOptions({
            rightOffset: 5,
            barSpacing: 10,
            minBarSpacing: 5,
            fixLeftEdge: true,
            borderVisible: false,
            timeVisible: true,
            tickMarkFormatter: (time, tickMarkType, locale) => {
                const date = new Date(parseFloat(time) * 1000);
                const timeFormatter = new Intl.DateTimeFormat(locale, {
                    hour12: true,
                    hour: "numeric",
                    minute: "numeric",
                });
                return timeFormatter.format(date);
            },
        });


        setChartReady(true);
        return () => [chart.current.remove()];
    }, [currentTimeFrame]);


    return (
        <>


            <div className='py-3'>
                <div className="candle-time-framer">
                    <p
                        className={
                            currentTimeFrame?.activeclass === "1m" ? "active" : ""
                        }
                        onClick={() =>
                            PeriodChangeFun({
                                period: "1m",
                                limit: 1000,
                                activeclass: "1m",
                            })
                        }
                    >
                        1m
                    </p>
                    <p
                        className={
                            currentTimeFrame?.activeclass === "5m" ? "active" : ""
                        }
                        onClick={() =>
                            PeriodChangeFun({
                                period: "5m",
                                limit: 1000,
                                activeclass: "5m",
                            })
                        }
                    >
                        5m
                    </p>
                    {/* <p
                        className={
                            currentTimeFrame?.activeclass === "15m" ? "active" : ""
                        }
                        onClick={() =>
                            PeriodChangeFun({
                                period: "15m",
                                limit: 1000,
                                activeclass: "15m",
                            })
                        }
                    >
                        15m
                    </p>
                    <p
                        className={
                            currentTimeFrame?.activeclass === "30m" ? "active" : ""
                        }
                        onClick={() =>
                            PeriodChangeFun({
                                period: "30m",
                                limit: 1000,
                                activeclass: "30m",
                            })
                        }
                    >
                        30m
                    </p>
                    <p
                        className={
                            currentTimeFrame?.activeclass === "1h" ? "active" : ""
                        }
                        onClick={() =>
                            PeriodChangeFun({
                                period: "1h",
                                limit: 1000,
                                activeclass: "1h",
                            })
                        }
                    >
                        1h
                    </p>
                    <p
                        className={
                            currentTimeFrame?.activeclass === "1d" ? "active" : ""
                        }
                        onClick={() =>
                            PeriodChangeFun({
                                period: "1d",
                                limit: 1000,
                                activeclass: "1d",
                            })
                        }
                    >
                        1d
                    </p> */}
                </div>
                <div className="user-live-data-show">
                    <div className="user-live-data">
                        <p>
                            Time:{" "}
                            {liveData?.time &&
                                dateFormat(
                                    parseFloat(liveData?.time),
                                    "yyyy-mm-dd h:MM TT"
                                )}
                        </p>
                        <p>Open: {liveData?.openSecond && parseFloat(liveData?.openSecond)}</p>
                        <p>High: {liveData?.high && parseFloat(liveData?.high)}</p>
                        <p>Low: {liveData?.low && parseFloat(liveData?.low)}</p>
                    </div>
                    <div className="user-live-data">
                        <p>Close: {liveData?.close && parseFloat(liveData?.close)}</p>
                        {/* <p>Volume: {liveData?.v && parseFloat(liveData?.v)}</p> */}
                    </div>
                </div>
                <div
                    ref={chartContainerRef}
                    style={{
                        width: "100%",
                        height: "100%",
                    }}
                ></div>
            </div>

        </>
    )
}

export default MobileNewCoinCandle;